import { getPathName } from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue, usePLCWriteState } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

import PLCTextInput from './PLCTextInput';

function PLCTextEditor({ field }) {
  const { activeWrite, runWrite } = usePLCWriteState();
  const plcValue = usePLCValue(field.path);
  const handle = getPathName(field.path);

  return (
    <PLCTextInput
      label={field.label}
      description={field.description}
      value={plcValue || ''}
      disabled={activeWrite === handle}
      onUpdate={(value) => runWrite({ path: field.path, value })}
    />
  );
}

PLCTextEditor.propTypes = {
  field: PropTypes.shape({
    description: PropTypes.string,
    label: PropTypes.string.isRequired,
    path: PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default PLCTextEditor;
